import { scriptsApi } from '../client'

export interface TiktokResolveResponse {
  video_id: string | null
  canonical_url: string | null
}

export const tiktokApi = {
  resolveVideo: (url: string): Promise<TiktokResolveResponse> =>
    scriptsApi.post('/tiktok/resolve-video', { url }).then((r) => r.data),
}
